// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HSF3","selected":"styles_selected__1n6CG"};